<template>
    <div id="cookie-declaration">

    </div>
</template>
<script>
import postscribe from 'postscribe';

export default {  
  
  mounted() {
    postscribe('#cookie-declaration', `<script id="CookieDeclaration" src="https://consent.cookiebot.com/80438e57-8e21-48a0-b3ae-1ccdbb6bc218/cd.js" async><\/script>`);
  }
}
</script>